import React from 'react';
import { Sidebar } from '@fingo/lib/components/layout';
import AnalyticsSideFinance from '../views/App/analytics/AnalyticsSideFinance';
import Tracker from '../views/App/analytics/analytics/Tracker';

const analyticsSubRoutes = () => [
  {
    id: 'analytics-side-finance',
    label: 'Financiero',
    path: 'finance',
    component: <AnalyticsSideFinance />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

export const analyticsTabs = () => [
  {
    id: 'tracker',
    label: 'Financiero',
    path: 'tracker',
    component: <Tracker />,
    disabled: false,
    show: true,
    showInSidebar: true,
  },
];

const analyticsRoutes = () => [
  {
    id: 'analytics',
    label: 'Analytics',
    path: '/app/analytics',
    component: <Sidebar options={analyticsSubRoutes()} />,
    disabled: false,
    show: false,
    showInNavbar: false,
    subRoutes: analyticsSubRoutes(),
  },
];

export default analyticsRoutes;
